import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import { Redirect } from 'react-router-dom'
import Login from './Login'



// const AuthGroupWrapper = ({ requiredGroups, children }) => {
//   const [userGroups, setUserGroups] = useState([]);

//   useEffect(() => {
//     (async () => {
//       const user = await Auth.currentAuthenticatedUser();
//       setUserGroups(user.signInUserSession.accessToken.payload['cognito:groups']);
//     })();
//   }, [requiredGroups])


//   const intersectionGroups = userGroups.filter((g) => requiredGroups.includes(g));
//   const userHasGroups = !userGroups ? false : true;
//   console.log(userHasGroups, userGroups);
//   console.log(intersectionGroups)

//   if (userHasGroups && intersectionGroups.length > 0) {
//     return ([children])
//   } else {
//     return <Redirect to={{ pathname: "/" }} />
//   }
// };

// AuthGroupWrapper.propTypes = {
//   children: PropTypes.node.isRequired,
//   requiredGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
// };

// This make certain components viewable by their user group...
// The html is wrapped 

// interacts with routes to show things based on what they are allowed to see.

// export default AuthGroupWrapper;

const AuthGroupWrapper = ({ requiredGroups, children }) => {
  const [userGroups, setUserGroups] = useState([]);

  useEffect(() => {
    (async () => {
      const user = await Auth.currentAuthenticatedUser();
      setUserGroups(user.signInUserSession.accessToken.payload['cognito:groups']);
    })();
  }, [requiredGroups])

  const shouldRender = () => {
    if (!userGroups) {
      return false;
    }
    const intersectionGroups = userGroups.filter((g) => requiredGroups.includes(g));
    return (intersectionGroups.length > 0);
  };

  return (
    <>
      {shouldRender() && children}
    </>
  )
};

AuthGroupWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  requiredGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
};


export default AuthGroupWrapper;